import { render, staticRenderFns } from "./DiscoveryGrid.vue?vue&type=template&id=4afca3df&scoped=true"
import script from "./DiscoveryGrid.vue?vue&type=script&lang=js"
export * from "./DiscoveryGrid.vue?vue&type=script&lang=js"
import style0 from "./DiscoveryGrid.vue?vue&type=style&index=0&id=4afca3df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afca3df",
  null
  
)

export default component.exports